import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const Results = ({ className, notifications, ...rest }) => {
  const classes = useStyles();
  const [selectedNotificationIds, setSelectedNotificationIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const handleSelectAll = (event) => {
    let newSelectedNotificationIds;

    if (event.target.checked) {
      newSelectedNotificationIds = notifications.map((notification) => notification.id);
    } else {
      newSelectedNotificationIds = [];
    }

    setSelectedNotificationIds(newSelectedNotificationIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedNotificationIds.indexOf(id);
    let newSelectedNotificationIds = [];

    if (selectedIndex === -1) {
      newSelectedNotificationIds = newSelectedNotificationIds.concat(selectedNotificationIds, id);
    } else if (selectedIndex === 0) {
      newSelectedNotificationIds = newSelectedNotificationIds.concat(selectedNotificationIds.slice(1));
    } else if (selectedIndex === selectedNotificationIds.length - 1) {
      newSelectedNotificationIds = newSelectedNotificationIds.concat(selectedNotificationIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedNotificationIds = newSelectedNotificationIds.concat(
        selectedNotificationIds.slice(0, selectedIndex),
        selectedNotificationIds.slice(selectedIndex + 1)
      );
    }

    setSelectedNotificationIds(newSelectedNotificationIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={selectedNotificationIds.length === notifications.length}
                    color="primary"
                    indeterminate={
                      selectedNotificationIds.length > 0
                      && selectedNotificationIds.length < notifications.length
                    }
                    onChange={handleSelectAll}
                  />
                </TableCell>
                <TableCell>
                  Notification
                </TableCell>
                <TableCell>
                  Subject
                </TableCell>
                <TableCell>
                  Category
                </TableCell>
                <TableCell>
                  Date
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {notifications.slice(0, limit).map((notification) => (
                <TableRow
                  hover
                  key={notification.id}
                  selected={selectedNotificationIds.indexOf(notification.id) !== -1}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedNotificationIds.indexOf(notification.id) !== -1}
                      onChange={(event) => handleSelectOne(event, notification.id)}
                      value="true"
                    />
                  </TableCell>
                  <TableCell>
                    <Box
                      alignItems="center"
                      display="flex"
                    >
                      <Typography
                        color="textPrimary"
                        variant="body1"
                      >
                        {notification.notification.text}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {notification.notification.subject}
                  </TableCell>
                  <TableCell>
                    {notification.notification.category}
                  </TableCell>
                  <TableCell>
                    {moment(notification.createdAt).format('hh:mm DD/MM/YYYY')}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={notifications.length}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Card>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  notifications: PropTypes.array.isRequired
};

export default Results;
